import MultiSelectSearch, { createFilter } from './multi-select-search';
export { createFilter };
export default MultiSelectSearch;
